import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/rosetai/app/swiss/SwissPageClient.js");
